import React, {useState, useEffect} from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import { fetchLeadsStatusSummary, fetchOrderStatusSummary, fetchRecentLeads } from "../../../api/api"; 
import { fetchCompletedOrdersMonthly } from "../../../api/api";
import { fetchNotifications} from "../../../api/api";
import { useTranslation } from "react-i18next";

interface Lead {
  leads_name: string;
  compy_name: string;
  phn1: string;
  phn2: string;
  leads_status: string;
  status: string;
  created_date: string;
  location?: string;
  leads_id?: string | number;
}
const ORDER_LABELS = [
  "Pending",
  "Customer Responded",
  "Approved",
  "On Work",
  "Completed",
  "Invoice Issued",
];

//leads by stage
const LEAD_STATUSES = [
  "New/Fresh",
  "Contacted/Attempted",
  "In progress/Working",
  "Qualified",
  "Unqualified/Disqualified",
  "Interested/Warm",
  "Negotiation/Proposal Sent",
  "Won/Converted",
  "Lost",
  "Follow-Up/On Hold",
];

const route = all_routes;
const LeadsDashboard = () => {
  const { t } = useTranslation();
  //states
  const [recentLeads, setRecentLeads] = useState<Lead[]>([]);
  const [loading, setLoading] = useState(true);
   const [selectedDays, setSelectedDays] = useState<number>(30); 
   const [selectedOrderDays, setSelectedOrderDays] = useState(30);

  const [chartOptions, setChartOptions] = useState<any>({
  series: [
    {
      name: t("Leads Count"),
      data: [],
    },
  ],

  chart: {
    type: "bar",
    height: 420,
    toolbar: { show: false },
  },

  colors: [
    "#3498db",
    "#1abc9c",
    "#e67e22",
    "#9b59b6",
    "#95a5a6",
    "#f1c40f",
    "#3f51b5",
    "#27ae60  ",
    "#e74c3c",
    "#ff9800",
  ],

  plotOptions: {
    bar: {
      horizontal: true,
      borderRadius: 6,
      borderRadiusApplication: "end",
      barHeight: "45%",
      distributed: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 15,
    style: {
      fontSize: "12px",
      fontWeight: 600,
      colors: ["#111"],
    },
  },

  xaxis: {
    categories: LEAD_STATUSES.map((status) => t(status)),
    labels: {
      style: {
        fontSize: "11px",
      },
    },
  },

  yaxis: {
    labels: {
      align: "left",
      minWidth: 220,
      maxWidth: 220,
      style: {
        fontSize: "12px",
        fontWeight: 500,
        colors: "#374151",
      },
    },
  },

  grid: {
    borderColor: "#e5e7eb",
    strokeDashArray: 4,
    padding: {
      left: 20,
      right: 20,
      top: 10,
      bottom: 10,
    },
  },

  tooltip: {
    theme: "light",
  },

  legend: {
    show: false,
  },
});

//fetch datas bar graph
useEffect(() => {
  fetchLeadsStatusSummary().then((data) => {
    const normalizedData = data.map((d: any) => ({
      status: d.status?.toLowerCase().trim(),
      count: Number(d.count),
    }));

    
    const counts = LEAD_STATUSES.map((status) => {
      const match = normalizedData.find(
        (item: any) => item.status === status.toLowerCase().trim()
      );
      return match ? match.count : 0;
    });

    // ✅ update chart
    setChartOptions((prev: any) => ({
      ...prev,
      series: [{ ...prev.series[0], data: counts }],
      xaxis: {
        ...prev.xaxis,
        categories: LEAD_STATUSES.map((status) => t(status)), // translated labels
      },
    }));

    console.log("Leads Status Data:", counts);
  });
}, [t]); // 🔥 VERY IMPORTANT

  const [chartOptions2] = useState<any>({
    series: [
      {
        data: [400, 220, 448],
        color: "#77D882",
      },
    ],
    chart: {
      type: "bar",
      height: 150,
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: [t("Conversation"), t("Follow Up"), t("Inpipeline")],
      min: 0,
      max: 500,
      tickAmount: 5,
    },
  });
  // pie chart
  const [chartOptions3, setChartOptions3] = useState<any>({
  series: [0, 0, 0, 0, 0, 0],

  options: {
    chart: { width: 400, height: 300, type: "pie" },
    legend: { position: "bottom" },
    labels: [
      "Pending",
      "Customer Responded",
      "Approved",
      "On Work",
      "Completed",
      "Invoice Issued",
    ],
    colors: ["#FF0000", "#FFD700", "#89CFF0", "#FFA500", "#32CD32", "#4169E1"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: { width: 275 },
          legend: { position: "bottom" },
        },
      },
    ],
  },
});

//pie chart
useEffect(() => {
  fetchOrderStatusSummary(selectedOrderDays).then((data) => {
    if (!data || data.length === 0) {
      console.warn("No order status data received");
      return; // keep default [0,0,0,0,0,0]
    }

    const normalizedData = data.map((d: any) => ({
      order_status: d.order_status?.toLowerCase().trim(),
      count: Number(d.count),
    }));

    const counts = ORDER_LABELS.map((label) => {
      const match = normalizedData.find(
        (item: any) => item.order_status === label.toLowerCase().trim()
      );
      return match ? match.count : 0;
    });

    setChartOptions3((prev: any) => ({
      ...prev,
      series: counts.length ? counts : prev.series,
    }));

    console.log("Final Pie Counts:", counts);
  });
}, [selectedOrderDays]);


  //area graph
  const [chartOptions4, setChartOptions4] = useState<any>({
  series: [{ name:t("Completed Orders"), data: Array(12).fill(0) }],
  colors: ["#4A00E5"],
  chart: { height: 273, type: "area", zoom: { enabled: false } },
  dataLabels: { enabled: false },
  title: { text: "", align: "left" },
  xaxis: {
    categories: [t("Jan"),
        t("Feb"),
        t("Mar"),
        t("Apr"),
        t("May"),
        t("Jun"),
        t("Jul"),
        t("Aug"),
        t("Sep"),
        t("Oct"),
        t("Nov"),
        t("Dec"),],
  },
  yaxis: { min: 0, tickAmount: 5 },
  legend: { position: "top", horizontalAlign: "left" },
});

useEffect(() => {
  const fetchData = async () => {
    try {
      const data = await fetchCompletedOrdersMonthly(); 
      const counts = Array(12).fill(0);

      data.forEach((item: any) => {
        const monthIndex = item.month_number - 1;
        if (monthIndex >= 0 && monthIndex < 12) {
          counts[monthIndex] = Number(item.completed_count);
        }
      });

      setChartOptions4((prev: any) => ({
        ...prev,
        series: [{ name: "Completed Orders", data: counts }],
      }));

      console.log("Completed Orders by Month:", counts);
    } catch (err) {
      console.error(err);
    }
  };

  fetchData();
}, []);



  const today = new Date();
const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

const initialSettings = {
  startDate: today,
  endDate: today,
  ranges: {
    "Last 7 Days": [
      new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6),
      today,
    ],
    "Last 30 Days": [
      new Date(today.getFullYear(), today.getMonth(), today.getDate() - 29),
      today,
    ],
    "This Month": [startOfMonth, endOfMonth],
    "Last Month": [
      new Date(today.getFullYear(), today.getMonth() - 1, 1),
      new Date(today.getFullYear(), today.getMonth(), 0),
    ],
    Today: [today, today],
    Yesterday: [
      new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
      new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
    ],
  },
  timePicker: false,
};

  // Fetch leads based on selectedDays
  const getRecentLeads = async (days: number) => {
    try {
      setLoading(true);
      const data = await fetchRecentLeads(days);
      setRecentLeads(data);
    } catch (error) {
      console.error("Error fetching recent leads:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRecentLeads(selectedDays);
  }, [selectedDays]);

   const handleDaysChange = (days: number) => {
    setSelectedDays(days);
  };

  //leads status clr
  const getStatusStyle = (status: string) => {
  const styles: Record<string, string> = {
    "New/Fresh": "#3498db",
    "Contacted/Attempted": "#1abc9c",
    "In progress/Working": "#e67e22",
    "Qualified": "#9b59b6",
    "Unqualified/Disqualified": "#95a5a6",
    "Interested/Warm": "#f1c40f",
    "Negotiation/Proposal Sent": "#3f51b5",
    "Won/Converted": "#27ae60",
    "Lost": "#e74c3c",
    "Follow-Up/On Hold": "#ff9800",
  };

  return styles[status] || "#3498db"; // default blue
};

//notifications
    useEffect(() => {
    const loadNotifications = async () => {
      try {
        const data = await fetchNotifications();
        console.log("Notifications:", data);
  
        //  Example: you can display them, or trigger alerts
        data.forEach((notification: any) => {
          
          console.log(" New Notification:", notification.event_title);
        });
  
      } catch (err) {
        console.error("Failed to fetch notifications:", err);
      }
    };
  
    loadNotifications();
  }, []);


  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <div className="row align-items-center ">
                  <div className="col-md-4">
                    <h3 className="page-title">{t("Leads Dashboard")}</h3>
                  </div>
                  <div className="col-md-8 float-end ms-auto">
                    <div className="d-flex title-head">
                      <div className="daterange-picker d-flex align-items-center justify-content-center">
                        <div className="form-sort me-2">
                          <i className="ti ti-calendar" />
                          <DateRangePicker initialSettings={initialSettings}>
                            <input
                              className="form-control bookingrange"
                              type="text"
                            />
                          </DateRangePicker>
                        </div>
                        <div className="head-icons mb-0">
                          <CollapseHeader />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-7">
              <div className="card">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h4>
                      <i className="ti ti-grip-vertical me-1" />
                     {t("Recently Created Leads")}
                    </h4>

                    {/* <div className="dropdown">
                      <Link
                        className="dropdown-toggle"
                        data-bs-toggle="dropdown"
                        to="#"
                      >
                        <i className="ti ti-calendar-check me-2" />
                        Last {selectedDays} days
                      </Link>
                      <div className="dropdown-menu dropdown-menu-end">
                        <button
                          className="dropdown-item"
                          onClick={() => setSelectedDays(15)}
                        >
                          Last 15 days
                        </button>
                        <button
                          className="dropdown-item"
                          onClick={() => setSelectedDays(30)}
                        >
                          Last 30 days
                        </button>
                      </div>
                    </div> */}


                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive custom-table">
                    <table className="table dataTable" id="lead-project">
                      <thead className="thead-light">
                        <tr>
                         <th>{t("Lead Name")}</th>
                        <th>{t("Company Name")}</th>
                        <th>{t("Phone")}</th>
                        <th>{t("Lead Status")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={4} className="text-center">
                               {t("Loading...")}
                            </td>
                          </tr>
                        ) : recentLeads.length > 0 ? (
                          recentLeads.map((lead, index) => (
                            <tr
                              key={index}
                              className={index % 2 === 0 ? "even" : "odd"}
                            >
                              <td>{lead.leads_name}</td>
                              <td>
                                <h2 className="d-flex align-items-center">
                                  <Link
                                    to={route.companyDetails}
                                    className="avatar avatar-sm border me-2"
                                  >
                                    <ImageWithBasePath
                                      className="w-auto h-auto"
                                      src="assets/img/icons/company-icon-01.svg"
                                      alt="User Image"
                                    />
                                  </Link>
                                  <Link
                                    to={route.companyDetails}
                                    className="d-flex flex-column"
                                  >
                                    {lead.compy_name}
                                    <span className="text-default">
                                      {lead.location || ""}
                                    </span>
                                  </Link>
                                </h2>
                              </td>
                              <td>{lead.phn1}</td>
                              <td>
                              <span
                                className="badge badge-pill badge-status"
                                style={{
                                  backgroundColor: getStatusStyle(lead.leads_status),
                                  color: "#fff",
                                }}
                              >
                                {lead.leads_status}
                              </span>
                            </td>

                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={4} className="text-center">
                               {t("No recent leads found")}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-5 d-flex">
              <div className="card w-100">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h4>
                      <i className="ti ti-grip-vertical me-1" />
                       {t("Orders By Stage")}
                    </h4>
                   </div>
                </div>
                <div className="card-body">
                  <div id="leadpiechart" style={{ minHeight: "320px" }}>
  <Chart
    options={chartOptions3.options}
    series={chartOptions3.series}
    type="pie"
    height={300}
  />
</div>

                </div>
              </div>
            </div>

          </div>
          <div className="row">
            <div className="col-md-12 d-flex">
              <div className="card w-100">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h4>
                      <i className="ti ti-grip-vertical me-1" />
                    {t("Orders completed in months")}
                    </h4>
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      {/* <div className="dropdown me-2">
                        <Link
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          to="#"
                        >
                          Sales Pipeline
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link to="#" className="dropdown-item">
                            Marketing Pipeline
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Sales Pipeline
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Email
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Chats
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Operational
                          </Link>
                        </div>
                      </div> */}
                      {/* <div className="dropdown">
                        <Link
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          to="#"
                        >
                          Last 30 Days
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link to="#" className="dropdown-item">
                            Last 30 Days
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Last 15 Days
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Last 7 Days
                          </Link>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div id="contact-report">
                    <Chart
                      options={chartOptions4}
                      series={chartOptions4.series}
                      type="area"
                      height={chartOptions4.chart.height}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h4>
                      <i className="ti ti-grip-vertical me-1" />
                      {t("Leads By Stage")}
                    </h4>
                    <div className="d-flex align-items-center flex-wrap row-gap-2">

                      

                      {/* <div className="dropdown">
                        <Link
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          to="#"
                        >
                          Last 3 months
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link to="#" className="dropdown-item">
                            Last 3 months
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Last 6 months
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Last 12 months
                          </Link>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="card-body"> 
                  <div id="last-chart">
                    <Chart
                      options={chartOptions}
                      series={chartOptions.series}
                      type={chartOptions.chart.type}
                      height={chartOptions.chart.height}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-md-6">
              <div className="card">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h4>
                      <i className="ti ti-grip-vertical me-1" />
                      Won Deals Stage
                    </h4>
                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                      <div className="dropdown me-2">
                        <Link
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          to="#"
                        >
                          Marketing Pipeline
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link to="#" className="dropdown-item">
                            Marketing Pipeline
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Sales Pipeline
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Email
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Chats
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Operational
                          </Link>
                        </div>
                      </div>
                      <div className="dropdown">
                        <Link
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                          to="#"
                        >
                          Last 3 months
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link to="#" className="dropdown-item">
                            Last 3 months
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Last 6 months
                          </Link>
                          <Link to="#" className="dropdown-item">
                            Last 12 months
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body ">
                  <div id="won-chart">
                    {" "}
                    <Chart
                      options={chartOptions2}
                      series={chartOptions2.series}
                      type={chartOptions2.chart.type}
                      height={chartOptions2.chart.height}
                    />
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadsDashboard;
